/* ZINKE Journal — Beitragsseite, 16.09.2026
   1. Blendet Abschnitte beim Scrollen ein (.zj-reveal -> .is-in)
   2. Leichte Parallaxe der Favoriten-Hintergründe (--zj-shift), nur Desktop
   Beides entfällt bei "Bewegung reduzieren" (System) oder body.motion-off. */
(function () {
  var root = document.querySelector('[data-zj]');
  if (!root) return;

  var ruhig = document.body.classList.contains('motion-off') ||
    (window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches);

  var items = root.querySelectorAll('.zj-reveal');
  if (ruhig || !('IntersectionObserver' in window)) {
    items.forEach(function (el) { el.classList.add('is-in'); });
    return;
  }

  var io = new IntersectionObserver(function (entries) {
    entries.forEach(function (e) {
      if (e.isIntersecting) {
        e.target.classList.add('is-in');
        io.unobserve(e.target);
      }
    });
  }, { rootMargin: '0px 0px -8% 0px', threshold: 0 });
  items.forEach(function (el) { io.observe(el); });

  /* Parallaxe nur mit Maus und breitem Fenster. Auf dem Handy scrollt der
     Browser auf einem eigenen Thread; jede Nachberechnung im Skript kommt
     dort einen Takt zu spät und wirkt wie Ruckeln. */
  var mitMaus = window.matchMedia && window.matchMedia('(hover: hover) and (pointer: fine) and (min-width: 750px)').matches;
  var bilder = Array.prototype.slice.call(root.querySelectorAll('[data-zj-parallax]'));
  if (!bilder.length || !mitMaus) return;

  var laeuft = false;
  function rechne() {
    laeuft = false;
    var vh = window.innerHeight;
    bilder.forEach(function (el) {
      var box = el.parentNode.getBoundingClientRect();
      if (box.bottom < -100 || box.top > vh + 100) return;
      var mitte = box.top + box.height / 2 - vh / 2;
      var shift = Math.max(-36, Math.min(36, mitte * -0.07));
      el.style.setProperty('--zj-shift', shift.toFixed(1) + 'px');
    });
  }
  function anstossen() {
    if (!laeuft) { laeuft = true; window.requestAnimationFrame(rechne); }
  }
  window.addEventListener('scroll', anstossen, { passive: true });
  window.addEventListener('resize', anstossen);
  rechne();
})();
